import { render, staticRenderFns } from "./LimitesConsumo.vue?vue&type=template&id=36e32660&scoped=true&"
import script from "./LimitesConsumo.vue?vue&type=script&lang=js&"
export * from "./LimitesConsumo.vue?vue&type=script&lang=js&"
import style0 from "./LimitesConsumo.vue?vue&type=style&index=0&id=36e32660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e32660",
  null
  
)

export default component.exports